import { QueryClient } from '@tanstack/react-query';

/**
 * Stale time pro GET dotaz detailu/editační stránky. Krátké okno (jednotky sekund) slouží jen k
 * deduplikaci rychlého překlikávání — po jeho vypršení se detail při každém otevření načte znovu, aby
 * uživatel needitoval zastaralá data. Globální default (5 min) je vhodný pro seznamy a číselníky, ne
 * pro editovatelné detaily. Viz `frontend/GUIDELINES.md` → „Detail stránky — čerstvost dat".
 */
export const DETAIL_QUERY_STALE_TIME_MS = 5_000;

/**
 * Výchozí konfigurace QueryClient.
 * Nastavení jsou optimalizovaná pro intranetovou aplikaci.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Stale time - jak dlouho jsou data považována za čerstvá
      staleTime: 1000 * 60 * 5, // 5 minut
      // Garbage collection time - jak dlouho držet data v cache
      gcTime: 1000 * 60 * 30, // 30 minut
      // Retry logika
      retry: (failureCount, error) => {
        // Neretry na 4xx chyby
        if (error instanceof Error && 'status' in error) {
          const status = (error as { status: number }).status;
          if (status >= 400 && status < 500) {
            return false;
          }
        }
        return failureCount < 3;
      },
      // Refetch při návratu na okno
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
